import { projectListSearchNuqs } from '@/features/search/_hooks/projects-search';
import { useDebouncedQueryStates } from '@/lib/nuqs';
import { parseAsInteger, parseAsString } from 'nuqs';

export const useProjectsPageSearchQueryStates = () => {
  const queryStates = useDebouncedQueryStates({
    ...projectListSearchNuqs,
    // グループ検索用
    groupInProjectsOrdering: parseAsString,
    groupInProjectsPage: parseAsInteger.withDefault(1),
  });
  return queryStates;
};

export type ProjectsPageSearchQueryStates = ReturnType<
  typeof useProjectsPageSearchQueryStates
>['searchQueryStates'];
